"use client";

import * as TooltipPrimitive from "@radix-ui/react-tooltip";
import React, { useState } from "react";
import { COLOR_TOKENS } from "~/designSystem/constants/token";

import { cn } from "~/core/generic/shadcn-utils";
import If from "~/core/ui/If";

import Avatar from "../Avatar";
import Icon from "../Icon";
import Key from "../Keys/Key";
import KeyStack from "../Keys/KeyStack";
import { KeyProps, KeyStackProps } from "../Keys/interfaces";

import { StyledTooltipContent, StyledTooltipContentText } from "./styled";
import { TooltipProps } from "./types";

const Tooltip: React.FC<TooltipProps> = ({
  children,
  contentText,
  shortcutKey,
  avatar,
  leftIcon,
  rightIcon,
  side = "bottom",
  wrapperClassName,
  showOnClick = false,
}) => {
  const [open, setOpen] = useState(false);

  return (
    <TooltipPrimitive.Provider delayDuration={300} skipDelayDuration={0}>
      <TooltipPrimitive.Root open={open} onOpenChange={setOpen}>
        <TooltipPrimitive.Trigger
          asChild
          onClick={e => {
            if (!showOnClick) return;
            e.stopPropagation();
            setOpen(true);
          }}
        >
          <div className={cn(wrapperClassName)}>{children}</div>
        </TooltipPrimitive.Trigger>
        <If
          condition={
            contentText || shortcutKey || avatar || leftIcon || rightIcon
          }
        >
          <TooltipPrimitive.Portal>
            <StyledTooltipContent
              side={side}
              sideOffset={4}
              className="z-[1000]"
            >
              {leftIcon && (
                <Icon name={leftIcon} color={COLOR_TOKENS.core.silver[1]} />
              )}
              {avatar && <Avatar {...avatar} size={18} />}
              {contentText && (
                <StyledTooltipContentText>
                  {contentText}
                </StyledTooltipContentText>
              )}
              {rightIcon && (
                <Icon name={rightIcon} color={COLOR_TOKENS.core.silver[1]} />
              )}
              {shortcutKey &&
                (Array.isArray((shortcutKey as KeyStackProps)?.keys) ? (
                  <KeyStack isWhite {...(shortcutKey as KeyStackProps)} />
                ) : (
                  <Key isWhite {...(shortcutKey as KeyProps)} />
                ))}
            </StyledTooltipContent>
          </TooltipPrimitive.Portal>
        </If>
      </TooltipPrimitive.Root>
    </TooltipPrimitive.Provider>
  );
};

Tooltip.displayName = TooltipPrimitive.Tooltip.displayName;

export default Tooltip;
